import React, { useState, useEffect } from "react";
import apiClient from "../../../../../../Config/apiClient";
import "./GeneralSettings.scss";
import Loader from "../../../../../../Context/Loader/Loader";
import { showErrorToast, showSuccessToast } from "../../../../../../Context/Toaster/Toaster";
import redIcon from "../../../../../../Assets/images/close-red.svg"

const generalSettingsPath = process.env.REACT_APP_HS_GENERAL_SETTINGS_BASE_PATH;

const GeneralSettings = () => {
  const [settings, setSettings] = useState(null);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file1Error, setFile1Error] = useState("");
  const [file2Error, setFile2Error] = useState("");
  const [loading, setLoading] = useState(false);
  const [removeCCFile, setRemoveCCFile] = useState(false);
  const [removeTCFile, setRemoveTCFile] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await apiClient.get(`${generalSettingsPath}/get`);
        if (res.data.status === "SUCCESS") {
          setSettings({ ...res.data.data, cc_terms_filename: "", tc_terms_filename: "" });
        }
      } catch (err) {
        console.error("Failed to fetch settings:", err);
      }
    };
    fetchSettings();
  }, []);

  const handleFileChange1 = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      setFile1Error("Only PDF files are allowed");
      setFile1(null);
    } else {
      setFile1(file);
      setFile1Error("");
    }
    e.target.value = null;
  };

  const handleFileChange2 = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      setFile2Error("Only PDF files are allowed");
      setFile2(null);
    } else {
      setFile2(file);
      setFile2Error("");
    }
    e.target.value = null;
  };


  const handleRemoveFile1 = () => {
    if (file1) {
      setFile1(null);
    } else {
      setSettings((prev) => ({ ...prev, cc_terms_filename: "" }));
      setRemoveCCFile(true);
    }
  };

  const handleRemoveFile2 = () => {
    if (file2) {
      setFile2(null);
    } else {
      setSettings((prev) => ({ ...prev, tc_terms_filename: "" }));
      setRemoveTCFile(true);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("auto_delete_notification", settings?.auto_delete_notification ? 1 : 0);
      formData.append("delete_intervel", settings?.delete_intervel || "");
      formData.append("notify_document_expiry", settings?.notify_document_expiry ? 1 : 0);
      formData.append("notify_intervel", settings?.notify_intervel || "");

      if (file1) {
        const renamedFile = new File([file1], "CC_Terms_and_Conditions.pdf", { type: file1.type });
        formData.append("cc_terms_file", renamedFile);
      } else if (removeCCFile) {
        formData.append("cc_terms_file", "");
      }

      if (file2) {
        const renamedFile = new File([file2], "TC_Terms_and_Conditions.pdf", { type: file2.type });
        formData.append("tc_terms_file", renamedFile);
      } else if (removeTCFile) {
        formData.append("tc_terms_file", "");
      }

      const res = await apiClient.put(`${generalSettingsPath}/update`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "SUCCESS") {
        setSettings((prev) => ({ ...prev, ...res.data.data, cc_terms_filename: "", tc_terms_filename: "" }));
        showSuccessToast("Settings updated successfully!");
        setFile1(null);
        setFile2(null);
        setRemoveCCFile(false);
        setRemoveTCFile(false);
      }
    } catch (err) {
      console.error("Failed to update settings:", err);
      showErrorToast("Error updating settings");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="report-wraper">
      <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
          <div className="report-tabinner">
            <div className="reportform-cover mt-0">
              <div className="vrt-split mb-3">
                <h3>Notifications</h3>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="cp-split">
                    <div className="hscommon-check">
                      <input className="common-check" type="checkbox" id="autoDelete" checked={!!settings?.auto_delete_notification} onChange={(e) => setSettings((prev) => ({ ...prev, auto_delete_notification: e.target.checked ? 1 : 0, }))} />
                      <label className="form-check-label" htmlFor="autoDelete">
                        Auto Delete Notifications Older Than <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <select className="common-select" value={settings?.delete_intervel || ""} onChange={(e) => setSettings((prev) => ({ ...prev, delete_intervel: e.target.value }))}>
                      <option>1 Week</option>
                      <option>2 Weeks</option>
                      <option>1 Month</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="cp-split">
                    <label className="fi-label">
                      Notify Document Expiry Before <span style={{ color: "red" }}>*</span>
                    </label>
                    <select className="common-select" value={settings?.notify_intervel || ""} onChange={(e) => setSettings((prev) => ({ ...prev, notify_intervel: e.target.value }))}>
                      <option>1 Week</option>
                      <option>2 Weeks</option>
                      <option>1 Month</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="vrt-split vrt-padding mt-2 mb-3">
                  <h3>Uploads</h3>
                </div>

                <div className="col-md-6">
                  <div className={`cp-split ${file1Error ? "error" : ""}`}>
                    <label className="fi-label">Construction Company Terms and Conditions</label>
                    <div className="hsfile-upload">
                      <div className="file-display">
                        <label className="file-upload-label">
                          {file1?.name || settings?.cc_terms_filename || ""}
                        </label>
                        {(file1 || settings?.cc_terms_filename) && (
                          <img src={redIcon} alt="Remove" className="remove-icon" onClick={handleRemoveFile1} />
                        )}
                      </div>
                      <label htmlFor="file1" className="browse-btn">Browse</label>
                      <input type="file" id="file1" accept=".pdf" onChange={handleFileChange1} />
                    </div>
                    {file1Error && <span className="error-text active">{file1Error}</span>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className={`cp-split ${file2Error ? "error" : ""}`}>
                    <label className="fi-label">Truck Company Terms and Conditions</label>
                    <div className="hsfile-upload">
                      <div className="file-display">
                        <label className="file-upload-label">
                          {file2?.name || settings?.tc_terms_filename || ""}
                        </label>
                        {(file2 || settings?.tc_terms_filename) && (
                          <img src={redIcon} alt="Remove" className="remove-icon" onClick={handleRemoveFile2} />
                        )}
                      </div>
                      <label htmlFor="file2" className="browse-btn">Browse</label>
                      <input type="file" id="file2" accept=".pdf" onChange={handleFileChange2} />
                    </div>

                    {file2Error && <span className="error-text active">{file2Error}</span>}
                  </div>
                </div>
              </div>

              <div className="row mt-3" style={{ marginBottom: '30px' }}>
                <div className="col-md-12">
                  <button className="cp-button generate-button" onClick={handleSave} disabled={loading}>
                    {loading ? <Loader /> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;